import { LoginComponent } from './pages/login/login.component';
import { Routes } from '@angular/router';
import { MainLayoutComponent } from './shared/ui/components/layout/main-layout.component';
import { UsersComponent } from './pages/users/users.component';
import { authGuard } from './core/auth/auth.guard';
import { AgentesComponent } from './pages/agents/agents.component';
import { ImprovePromptManualComponent } from './pages/improve-prompt-manual/improve-prompt-manual.component';
import { ChatbotComponent } from './pages/chatbot/chatbot.component';
import { DocumentationComponent } from './pages/documentation/documentation.component';
import { AgentTypesComponent } from './pages/agent-types/agent-types.component';

export const routes: Routes = [
	{
		path: 'login',
		component: LoginComponent
	},
	{
		path: '',
		component: MainLayoutComponent,
		canActivate: [authGuard],
		children: [
			{
				path: '',
				redirectTo: 'users',
				pathMatch: 'full'
			},
			{
				path: 'users',
				component: UsersComponent
			},
			{
			    path: 'agent-types',
				component: AgentTypesComponent
			},
			{
			    path: 'documentation',
				component: DocumentationComponent
			},
			{
			    path: 'agents',
				component: AgentesComponent
			},
			{
			    path: 'improve-prompt-manual',
				component: ImprovePromptManualComponent
			},
			{
			    path: 'chatbot-test',
				component: ChatbotComponent
			}
		]
	}
]
